import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * A node in the accounting workflow map: small icon above a label with
 * an optional description. Clicking navigates to the module.
 */
export default function WorkflowItem({ icon: Icon, label, desc, path, emphasized, color }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className={`wf-item ${emphasized ? 'emphasized' : ''} ${color === 'green' ? 'green' : ''}`}
      onClick={() => path && navigate(path)}
      title={desc || label}
    >
      <span className="wf-item-icon">{Icon && <Icon />}</span>
      <span className="wf-item-label">{label}</span>
      {desc && <span className="wf-item-desc">{desc}</span>}
    </button>
  );
}
